import ApiClient from '@shoflo/api.v2-client';

/**
 * Gets the api client
 * @returns {*}
 */
export const getApiClient = () => {
  const { hostname, protocol, port } = window.location;

  return new ApiClient({
    endpoint: `${protocol}//${hostname}:${port}`,
    proxy: true
  });
};
